import React from 'react';
import './LoaderFullScreen.css'; 

const LoaderFullScreen = () => {
  return (
    <div className="full-screen-loader">
      <span className="loader"></span>
    </div>
  );
};

export default LoaderFullScreen;
